var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5742 12.1349L15.8865 8.26624V10.1126C15.8865 11.0639 15.4248 11.7442 14.0432 11.7442H1.30163C1.25834 11.7442 1.21611 11.7403 1.17353 11.7378L1.90028 14.743C1.96664 15.1167 2.17423 15.4417 2.48508 15.6585C2.72603 15.8271 3.00671 15.9148 3.2945 15.9148C3.37754 15.9148 3.46199 15.9073 3.54574 15.8924L15.4248 13.781C15.7981 13.7147 16.1235 13.5074 16.3403 13.1966C16.5572 12.8857 16.6405 12.5082 16.5742 12.1349Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5003 2.01207V2.75986H0.596436V2.01207C0.596436 1.22926 1.23304 0.592651 2.01585 0.592651H14.0809C14.8637 0.592651 15.5003 1.22926 15.5003 2.01207Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.596436 5.07298H15.5003V9.81884C15.5003 10.6017 14.8637 11.2383 14.0809 11.2383H2.01585C1.23304 11.2383 0.596436 10.6017 0.596436 9.81884V5.07298ZM9.02328 6.16717H2.63347V7.44514H9.02328V6.16717Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.bf395c61e04c133fc683da5550712055.svg";
export { ForwardRef as ReactComponent };